import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
/*
Hamburger menu trigger
*/
const $hamburger = $('.hamburger');
const $navprimary = $('.nav-primary');

function openMenu(hamburger, menu) {
  // if (window.matchMedia('(max-width: 992px)').matches) {
  hamburger.addClass('is-active');
  menu.addClass('is-active');
  disableBodyScroll(menu, { reserveScrollBarGap: true });
  // }
}

function closeMenu(hamburger, menu) {
  // if (window.matchMedia('(max-width: 992px)').matches) {
  hamburger.removeClass('is-active');
  menu.removeClass('is-active');
  enableBodyScroll(menu);
  // }
}

$hamburger.on('click', function () {
  if ($(this).hasClass('is-active')) {
    closeMenu($hamburger, $navprimary);
  } else {
    openMenu($hamburger, $navprimary);
  }
});

$navprimary
  .find('a')
  .not('.dropdown-toggle')
  .on('click', () => closeMenu($hamburger, $navprimary));
/*
    nav bar dropdown on hover
   */
// const $dropdown = $('.dropdown');
// const $dropdownToggle = $('.dropdown-toggle');
// const $dropdownMenu = $('.dropdown-menu');
// const showClass = 'show';

$(window).on('load resize', () => {
  const headerHeight = $('header.banner').innerHeight();

  const windowHeight = $(window).innerHeight();

  $('.nav-primary').innerHeight(windowHeight - headerHeight);
  const searchDropdown = document.querySelector(
    '.search-dropdown .dropdown-menu'
  );
  if (window.matchMedia('(max-width: 991px)').matches) {
    searchDropdown.classList.add('show');
  } else {
    closeMenu($hamburger, $navprimary);
    searchDropdown.classList.remove('show');
  }
  // if (this.matchMedia('(min-width: 992px)').matches) {
  //   document.querySelector('.search-dropdown').show();
  // $dropdown.on('mouseenter', function () {
  //   const $this = $(this);
  //   $this.addClass(showClass);
  //   $this.find($dropdownToggle).attr('aria-expanded', 'true');
  //   $this.find($dropdownMenu).addClass(showClass);
  // });

  // $dropdown.on('mouseleave', function () {
  //   const $this = $(this);
  //   $this.removeClass(showClass);
  //   $this.find($dropdownToggle).attr('aria-expanded', 'false');
  //   $this.find($dropdownMenu).removeClass(showClass);
  // });
  // } else {
  // $dropdown.off('mouseenter mouseleave');
  // }
});
